import CreateUsuario from '@/features/users/components/create-usuario'
export function CadastrarContabilidadePage() {
  return <CreateUsuario />
}
